<div class="lum-c-cost-layer-changes-dumb-log">
  <ag-grid-angular
    class="ag-theme-alpine ag-theme-lum ag-theme-lum--next"
    [columnDefs]="columnDefs"
    [gridOptions]="agGridOptions"
    [rowData]="changes"
    (gridReady)="handleGridReady($event)"
    (modelUpdated)="handleModelUpdated()"
    (paginationChanged)="handlePaginationChanged($event)"
  ></ag-grid-angular>
  <div *ngIf="_paging" class="lum-paging lum-paging--dodge-back-to-top">
    <mat-paginator
      [length]="_paging.total || 0"
      [pageSize]="_paging.per_page"
      [pageSizeOptions]="PAGE_SIZE_OPTIONS"
      [pageIndex]="(_paging.current_page || 1) - 1"
      (page)="handlePage($event)"
    ></mat-paginator>
  </div>
</div>
